// import components
import { LoadingButton } from '@mui/lab';
import { Box, Button, styled } from '@mui/material';
import { GridCompact6 } from 'components/shared/Grid/Grid.components';

// import hooks
import { useTranslation } from 'react-i18next';

const StyledEditFooter = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 30px 0 0;
  width: 100%;
`;

type Props = {
  onCancelClick: () => void;
  onClickSave?: (e: React.MouseEvent) => void;
  submitDisabled: boolean;
};

export default function EditFooter({
  onCancelClick,
  submitDisabled,
  onClickSave
}: Props) {
  const { t } = useTranslation();
  return (
    <StyledEditFooter
      sx={{
        zIndex: 30
      }}
    >
      <GridCompact6 mr={2}>
        <Button variant="text" color="primary" onClick={onCancelClick}>
          {t('cancel')}
        </Button>
      </GridCompact6>
      <GridCompact6>
        <LoadingButton
          type="submit"
          variant="contained"
          autoFocus
          color="primary"
          disabled={submitDisabled}
          onClick={onClickSave}
        >
          {t('save')}
        </LoadingButton>
      </GridCompact6>
    </StyledEditFooter>
  );
}
